<template>
    <div class="about-area news " style="padding-top: 60px">
        <div class="container-fluid">
            <div class="section-header text-center">
                <h2 class="section-title wow fadeInDown " data-wow-delay="0.3s">{{$t('news.title')}}</h2>
                <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
            </div>
            <div class="col-12">
                <div class="item-new row text-left " v-bind:id="'notice'+index" v-for="(item, index) in listNews" v-bind:class="{ 'bg-gray': (index %=2) }" >

                    <!--              <h3 class="section-title">Coming Soon</h3>-->
                    <div class="col-3 col-md-3 wow fadeInLeft d-none d-md-block d-lg-block" data-wow-delay="0.3s">
                        <img class="img-fluid" v-bind:src="'../assets/data/news/images/'+item[activeLang].poster+'.jpg'" alt="" >
                    </div>
                    <div class="col-12 col-md-9">
                        <h4  class="section-title wow fadeInDown" data-wow-delay="0.3s">{{item[activeLang].title}}</h4>
                        <div class="col-12 image-center d-block d-sm-none">
                            <img class="img-fluid" v-bind:src="'../assets/data/news/images/'+item[activeLang].poster+'.jpg'" alt="" >
                        </div>
                        <div class="col-12 info text-left no-padding">
                            <div class="about-wrapper wow fadeInDown" data-wow-delay="0.6s">
                                <div class="content">
                                    <template v-for="(txt, i) in item[activeLang].texts">
                                        <p >{{txt}}</p>
                                    </template>
                                    <h5>{{item[activeLang].subTitle}}</h5>
                                    <template v-if="item[activeLang].readMore && item[activeLang].readMore.external">
                                        <a target="_blank" v-bind:href="item[activeLang].readMore.link" class="btn btn-border mt-3 no-padding">
                                            {{$t('readMore')}} <i class="fa fa-link"></i>
                                        </a>
                                    </template>
                                    <template v-if="item[activeLang].readMore && !item[activeLang].readMore.external">
                                        <a  v-on:click="item[activeLang].collapsed = !item[activeLang].collapsed" class="btn btn-border mt-3 line-out no-padding" >
                                            <template v-if="!item[activeLang].collapsed">{{$t('readMore')}}</template>
                                            <template v-if="item[activeLang].collapsed">{{$t('readLess')}}</template>
                                            <i class="fa " v-bind:class="{ 'fa-angle-down': !item[activeLang].collapsed , 'fa-angle-up': item[activeLang].collapsed }"></i>
                                        </a>
                                        <div v-if="item[activeLang].collapsed"  class="text-justify animated zoomIn" >
                                            <div class="col-12 text-left" >
                                                <template v-for="(readTxt, i) in item[activeLang].readMore.texts">
                                                    <p >{{readTxt}}</p>
                                                </template>
                                            </div>
                                        </div>

<!--                                        <a v-b-toggle class="btn btn-border mt-3 line-out no-padding" v-bind:href="'#readmore-'+item[activeLang].poster" @click.prevent>{{$t('readMore')}}</a>-->
<!--                                        <b-collapse v-bind:id="'#readmore-'+item[activeLang].poster" class="text-justify" >-->
<!--                                            <div class="col-12 wow fadeInRight  text-left" data-wow-delay="0.8s">-->
<!--                                                <template v-for="(readTxt, i) in item[activeLang].readMore.texts">-->
<!--                                                    <p >{{readTxt}}</p>-->
<!--                                                </template>-->
<!--                                            </div>-->
<!--                                        </b-collapse>-->

                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
                </div>


            </div>

        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "Notices",
        data() {
            return {
                listNews: this.$store.getters.news,
                activeLang: this.$store.getters.lang
            }
        },
        created: function () {
            // console.log('NOTICIAS -> ',this.$store.getters.news);
        },
        computed: mapState(['news', 'lang']),
        watch: {
            news(newValue, oldValue) {
                this.listNews = newValue;

            },
            lang(newValue, oldValue) {
                this.activeLang = newValue;

            },
        }
    }
</script>

<style lang="scss">


 ul{
     margin-left: 15px;
 }
    .item-new{
        padding-top: 20px;
        .image-center{
            height: 150px;
            img{
                position: absolute;
                margin: auto;
                width: 150px;
                left: 0;
                /*right: 0;*/
            }
        }
         h4{
             &.section-title{
                 color:$primary-color;
             }
         }

        a.btn{
            color:$secundary-color !important;
            &:hover{
                color:$primary-color !important;
                border: none !important;
                padding: 0;
                margin: 0;
            }
            i{
                margin-left: 5px;
            }
        }
    }
</style>
